webpackJsonp([7],{

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(70);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["a"] = ({
    dateFormat: function dateFormat() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
        var fmt = arguments[1];

        date = new Date(date);
        var o = {
            'M+': date.getMonth() + 1,
            'd+': date.getDate(),
            'h+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds(),
            'q+': Math.floor((date.getMonth() + 3) / 3),
            'S': date.getMilliseconds() };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
        }

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(o).forEach(function (k) {
            if (new RegExp('(' + k + ')').test(fmt)) {
                fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
            }
        });

        return fmt;
    }
});

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(131);
module.exports = __webpack_require__(395);


/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProgressBar_vue__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProgressBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ProgressBar_vue__);








var loading = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$loading = new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_4__components_ProgressBar_vue___default.a).$mount();

var _createApp = Object(__WEBPACK_IMPORTED_MODULE_3__app__["a" /* createApp */])(),
    app = _createApp.app,
    router = _createApp.router,
    store = _createApp.store;

document.body.appendChild(loading.$el);

var firstPaint = true;

var APP_HEADER_HEIGHT = 52;

if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
}

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].mixin({
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        var asyncData = this.$options.asyncData;

        if (asyncData) {
            loading.start();
            asyncData.call(this, {
                store: this.$store,
                route: to
            }).then(function () {
                loading.finish();
                next();
            }).catch(next);
        } else {
            next();
        }
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            if (firstPaint) {
                firstPaint = false;
                return;
            }

            var $el = vm.$el;

            var scrollTop = vm.$store.state.appShell.historyPageScrollTop[to.path] || 0;
            $el.classList.add('enable-scroll');
            $el.scrollTop = scrollTop;

            vm.$store.dispatch('appShell/' + (to.meta.swipeBack ? 'enable' : 'disable') + 'SwipeBack');
        });
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        var $el = this.$el;
        var currentWindowHeight = window.innerHeight;
        var scrollTop = window.pageYOffset || 0;

        this.$root.$refs.appView.$el.style.height = currentWindowHeight - APP_HEADER_HEIGHT + 'px';

        $el.classList.add('enable-scroll');
        $el.scrollTop = scrollTop;

        this.$store.dispatch('appShell/saveScrollTop', { path: from.path, scrollTop: scrollTop });
        next();
    }
});

router.beforeResolve(function (to, from, next) {
    var matched = router.getMatchedComponents(to);
    var prevMatched = router.getMatchedComponents(from);

    var diffed = false;
    var activated = matched.filter(function (c, i) {
        return diffed || (diffed = prevMatched[i] !== c);
    });

    if (!activated.length) {
        return next();
    }

    loading.start();
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(activated.map(function (c) {
        if (c.asyncData && (!c.asyncDataFetched || to.meta.notKeepAlive)) {
            return c.asyncData({
                store: store,
                route: to
            }).then(function () {
                c.asyncDataFetched = true;
            });
        }
    })).then(function () {
        loading.finish();
        next();
    }).catch(next);
});

router.onReady(function () {
    return app.$mount('#app');
});

/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createApp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_vue__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon_vue__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_filters__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex_router_sync__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuex_router_sync__);













__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon_vue___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__util_filters__["a" /* default */]).forEach(function (key) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter(key, __WEBPACK_IMPORTED_MODULE_8__util_filters__["a" /* default */][key]);
});

function createApp() {
    var router = Object(__WEBPACK_IMPORTED_MODULE_4__router__["a" /* createRouter */])();
    var app = new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        router: router,
        store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
        filters: __WEBPACK_IMPORTED_MODULE_8__util_filters__["a" /* default */]
    }, __WEBPACK_IMPORTED_MODULE_6__App_vue___default.a));
    Object(__WEBPACK_IMPORTED_MODULE_9_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */], router);
    return { app: app, router: router, store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */] };
}
__WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon_vue___default.a.register({
    'svg-sentiment-very-satisfied': {
        width: 48,
        height: 48,
        d: 'M23.99 4C12.94 4 4 12.95 4 24s8.94 20 19.99 20S44 35.05 44 24 35.04 4 23.99 4zM24 40c-8.84 0-16-7.16-16-16S15.16 8 24 8s16 7.16 16 16-7.16 16-16 16zm2-20.12L28.12 22l2.12-2.12L32.36 22l2.13-2.12-4.25-4.24zm-8.24 0L19.88 22 22 19.88l-4.24-4.24-4.25 4.24L15.64 22zM24 35c4.66 0 8.62-2.92 10.22-7H13.78c1.6 4.08 5.56 7 10.22 7z'
    }
});

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(49);






var Home = function Home() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 511));
};
var Detail = function Detail() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 512));
};
var NotFound = function NotFound() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 513));
};
var User = function User() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 514));
};
var Search = function Search() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 515));
};
var Favor = function Favor() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 516));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

function createRouter() {
    var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
        mode: 'hash',

        base: __webpack_require__.p,

        routes: [{
            path: '/',
            name: 'home',
            component: Home
        }, {
            path: '/detail/:nid',
            name: 'detail',
            component: Detail,
            meta: {
                swipeBack: true
            }
        }, {
            path: '/user',
            name: 'user',
            component: User
        }, {
            path: '/search',
            name: 'search',
            component: Search,
            meta: {
                swipeBack: true
            }
        }, {
            path: '/favor',
            name: 'favor',
            component: Favor,
            meta: {
                swipeBack: true
            }
        }, {
            path: '*',
            name: 'notFound',
            component: NotFound
        }]
    });

    var SLIDE_LEFT = 'slide-left';

    var SLIDE_RIGHT = 'slide-right';

    router.beforeEach(function (to, from, next) {
        if (router.app.$store) {
            if (router.app.$store.state.appShell.needPageTransition) {
                var pageTransitionName = isForward(to, from) ? SLIDE_LEFT : SLIDE_RIGHT;
                router.app.$store.commit('appShell/' + __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["p" /* SET_PAGE_TRANSITION_NAME */], { pageTransitionName: pageTransitionName });
            }
        }
        next();
    });

    return router;
}

var ALWAYS_BACK_PAGE = ['home'];

var ALWAYS_FORWARD_PAGE = [];

var HISTORY_STACK = [];

function isForward(to, from) {
    if (to.name && ALWAYS_BACK_PAGE.indexOf(to.name) !== -1) {
        HISTORY_STACK.length = 0;
        return false;
    }

    if (from.name && ALWAYS_BACK_PAGE.indexOf(from.name) !== -1) {
        HISTORY_STACK.push(to.fullPath);
        return true;
    }

    if (to.name && ALWAYS_FORWARD_PAGE.indexOf(to.name) !== -1) {
        HISTORY_STACK.push(to.fullPath);
        return true;
    }

    var index = HISTORY_STACK.indexOf(to.fullPath);
    if (index !== -1) {
        HISTORY_STACK.length = index + 1;
        return false;
    }

    HISTORY_STACK.push(to.fullPath);
    return true;
}

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_app_shell__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_news__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_search__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_favor__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_detail__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_category__ = __webpack_require__(473);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        appShell: __WEBPACK_IMPORTED_MODULE_2__modules_app_shell__["a" /* default */],
        news: __WEBPACK_IMPORTED_MODULE_3__modules_news__["a" /* default */],
        search: __WEBPACK_IMPORTED_MODULE_4__modules_search__["a" /* default */],
        favor: __WEBPACK_IMPORTED_MODULE_5__modules_favor__["a" /* default */],
        detail: __WEBPACK_IMPORTED_MODULE_6__modules_detail__["a" /* default */],
        category: __WEBPACK_IMPORTED_MODULE_7__modules_category__["a" /* default */]
    }
}));

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(49);




var _mutations, _mutations3, _mutations4;



var state = {
    needPageTransition: true,

    isPageSwitching: false,

    pageTransitionName: '',

    overflowScrollingTouch: false,

    enableSwipeBack: false,

    historyPageScrollTop: {}
};

var actions = {
    enablePageTransition: function enablePageTransition(_ref) {
        var commit = _ref.commit;

        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* ENABLE_PAGE_TRANSITION */], true);
    },
    disablePageTransition: function disablePageTransition(_ref2) {
        var commit = _ref2.commit;

        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* DISABLE_PAGE_TRANSITION */], false);
    },
    setPageSwitching: function setPageSwitching(_ref3, isPageSwitching) {
        var commit = _ref3.commit;

        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["o" /* SET_PAGE_SWITCHING */], isPageSwitching);
    },
    saveScrollTop: function saveScrollTop(_ref4, _ref5) {
        var commit = _ref4.commit;
        var path = _ref5.path,
            scrollTop = _ref5.scrollTop;

        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* SAVE_SCROLLTOP */], { path: path, scrollTop: scrollTop });
    },
    disableOverflowScrollingTouch: function disableOverflowScrollingTouch(_ref6) {
        var commit = _ref6.commit;

        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["u" /* UPDATE_OVERFLOW_SCROLLING_TOUCH */], false);
    },
    enableOverflowScrollingTouch: function enableOverflowScrollingTouch(_ref7) {
        var commit = _ref7.commit;

        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["u" /* UPDATE_OVERFLOW_SCROLLING_TOUCH */], true);
    },
    enableSwipeBack: function enableSwipeBack(_ref8) {
        var commit = _ref8.commit;

        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["w" /* UPDATE_SWIPE_BACK */], true);
    },
    disableSwipeBack: function disableSwipeBack(_ref9) {
        var commit = _ref9.commit;

        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["w" /* UPDATE_SWIPE_BACK */], false);
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["o" /* SET_PAGE_SWITCHING */], function (state, isPageSwitching) {
    state.isPageSwitching = isPageSwitching;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["p" /* SET_PAGE_TRANSITION_NAME */], function (state, _ref10) {
    var pageTransitionName = _ref10.pageTransitionName;

    state.pageTransitionName = pageTransitionName;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* SAVE_SCROLLTOP */], function (state, _ref11) {
    var path = _ref11.path,
        scrollTop = _ref11.scrollTop;

    state.historyPageScrollTop[path] = scrollTop;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["u" /* UPDATE_OVERFLOW_SCROLLING_TOUCH */], function (state, flag) {
    state.overflowScrollingTouch = flag;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["w" /* UPDATE_SWIPE_BACK */], function (state, flag) {
    state.enableSwipeBack = flag;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,

    actions: actions,
    mutations: mutations,
    state: state,

    modules: {
        appHeader: {
            namespaced: true,
            state: {
                show: true,

                title: 'Lavas',

                logoIcon: '',

                showMenu: false,

                showFavor: false,

                showBack: false,

                showLogo: true,

                actions: []
            },
            actions: {
                setAppHeader: function setAppHeader(_ref12, appHeader) {
                    var commit = _ref12.commit;

                    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* SET_APP_HEADER */], appHeader);
                }
            },
            mutations: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* SET_APP_HEADER */], function (state, appHeader) {
                state.appHeader = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, appHeader);
            })
        },

        appSidebar: {
            namespaced: true,
            state: {
                show: false,
                slideFrom: 'left',
                title: {
                    imageLeft: '',
                    altLeft: '',
                    svgLeft: '',
                    iconLeft: 'home',
                    text: '个人中心',
                    imageRight: '',
                    altRight: '',
                    svgRight: '',
                    iconRight: ''
                },

                width: 0.75,

                showWidthThreshold: 0.25,

                enableSwipeOut: false,

                user: null,

                blocks: [{
                    list: [{
                        text: '收藏',
                        icon: 'star',
                        route: '/favor'
                    }]
                }, {
                    list: [{
                        text: '消息通知',
                        icon: 'message'
                    }, {
                        text: '用户反馈',
                        icon: 'feedback'
                    }, {
                        text: '系统设置',
                        icon: 'settings'
                    }]
                }]
            },
            actions: {
                showSidebar: function showSidebar(_ref13) {
                    var commit = _ref13.commit;

                    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["q" /* SET_SIDEBAR_VISIBILITY */], true);
                },
                hideSidebar: function hideSidebar(_ref14) {
                    var commit = _ref14.commit;

                    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["q" /* SET_SIDEBAR_VISIBILITY */], false);
                },
                enableSwipeOut: function enableSwipeOut(_ref15) {
                    var commit = _ref15.commit;

                    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["r" /* SET_SWIPE_OUT */], true);
                },
                disableSwipeOut: function disableSwipeOut(_ref16) {
                    var commit = _ref16.commit;

                    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["r" /* SET_SWIPE_OUT */], false);
                },
                accountLogin: function accountLogin(_ref17, userInfo) {
                    var commit = _ref17.commit;

                    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                        setTimeout(function () {
                            commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["s" /* SET_USER_INFO */], {
                                name: userInfo.name,
                                location: '中国北京',
                                email: 'example@baidu.com'
                            });
                            commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* ADD_SIDEBAR_BLOCKS */], {
                                name: 'logout',
                                list: [{
                                    text: '退出账户',
                                    icon: 'exit_to_app',
                                    action: 'logout'
                                }]
                            });
                            resolve();
                        }, 1000);
                    });
                },
                accountLogout: function accountLogout(_ref18) {
                    var commit = _ref18.commit;

                    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                        setTimeout(function () {
                            commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["s" /* SET_USER_INFO */], null);
                            commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* RM_SIDEBAR_BLOCKS */], 'logout');
                            resolve();
                        }, 1000);
                    });
                }
            },
            mutations: (_mutations3 = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations3, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["q" /* SET_SIDEBAR_VISIBILITY */], function (state, sidebarVisibility) {
                state.show = sidebarVisibility;
            }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations3, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["r" /* SET_SWIPE_OUT */], function (state, enable) {
                state.enableSwipeOut = enable;
            }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations3, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["s" /* SET_USER_INFO */], function (state, userInfo) {
                state.user = userInfo;
            }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations3, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* ADD_SIDEBAR_BLOCKS */], function (state, block) {
                state.blocks.push(block);
            }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations3, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* RM_SIDEBAR_BLOCKS */], function (state, name) {
                for (var i = 0; i < state.blocks.length; i++) {
                    if (state.blocks[i].name === name) {
                        state.blocks.splice(i, 1);
                    }
                }
            }), _mutations3)
        },

        appBottomNavigator: {
            namespaced: true,
            state: {
                show: true,

                navs: [{
                    name: 'home',

                    icon: 'home',

                    text: '主页',

                    active: true,

                    route: {
                        name: 'home',
                        path: '/'
                    }
                }, {
                    name: 'user',

                    icon: 'person',

                    text: '个人中心',

                    route: '/user'
                }]
            },
            actions: {
                hideBottomNav: function hideBottomNav(_ref19) {
                    var commit = _ref19.commit;

                    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* SET_APP_BOTTOM_NAV */], { show: false });
                },
                showBottomNav: function showBottomNav(_ref20) {
                    var commit = _ref20.commit;

                    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* SET_APP_BOTTOM_NAV */], { show: true });
                },
                activateBottomNav: function activateBottomNav(_ref21, name) {
                    var commit = _ref21.commit;

                    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* ACTIVATE_APP_BOTTOM_NAV */], name);
                }
            },
            mutations: (_mutations4 = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations4, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* ACTIVATE_APP_BOTTOM_NAV */], function (state, name) {
                state.navs = state.navs.map(function (nav) {
                    nav.active = nav.name === name;
                    return nav;
                });
            }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations4, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* SET_APP_BOTTOM_NAV */], function (state, appBottomNavigator) {
                state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, appBottomNavigator);
            }), _mutations4)
        }
    }
});

/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutation_types__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_filters__ = __webpack_require__(190);











function dataProcess(item) {
    item.show = __WEBPACK_IMPORTED_MODULE_7__util_filters__["a" /* default */].dateFormat(+item.ts, 'yyyy-MM-dd hh:mm:ss');
    return item;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        data: {}
    },
    actions: {
        getNewsList: function getNewsList(_ref, category) {
            var _this = this;

            var commit = _ref.commit,
                state = _ref.state;
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getNewsData({ category: category });

                            case 3:
                                data = _context.sent;

                                commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["n" /* SET_NEWS_DATA */], { category: category, data: data });
                                _context.next = 9;
                                break;

                            case 7:
                                _context.prev = 7;
                                _context.t0 = _context['catch'](0);

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[0, 7]]);
            }))();
        },
        selectTab: function selectTab(_ref2, category) {
            var _this2 = this;

            var commit = _ref2.commit,
                state = _ref2.state;
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!state.data[category]) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                _context2.prev = 2;
                                _context2.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getNewsData({ category: category });

                            case 5:
                                data = _context2.sent;

                                commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["n" /* SET_NEWS_DATA */], { category: category, change: true, data: data });
                                _context2.next = 11;
                                break;

                            case 9:
                                _context2.prev = 9;
                                _context2.t0 = _context2['catch'](2);

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[2, 9]]);
            }))();
        }
    },
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["n" /* SET_NEWS_DATA */], function (state, _ref3) {
        var data = _ref3.data,
            category = _ref3.category,
            change = _ref3.change;

        data.news = data && data.news && data.news.filter(function (item) {
            return item.sourcets;
        }).map(dataProcess);

        if (data.banner) {
            data.banner = data.banner.map(dataProcess);
        }

        if (data.news && data.news.length) {
            if (change) {
                state.data[category] = data;
                state.lastListLen = 0;
            } else {
                if (state.data[category] && state.data[category].news) {
                    state.lastListLen = state.data[category].news.length;
                    state.data[category].news = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.data[category].news), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(data.news));
                }
                state.loaded = 'loaded';
            }
            state.data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.data);
        } else {
            state.loaded = 'complete';
        }
    })
});

/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(49);








/* harmony default export */ __webpack_exports__["a"] = ({

    state: {
        result: []
    },

    actions: {
        query: function query(_ref, _query) {
            var _this = this;

            var commit = _ref.commit;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["v" /* UPDATE_RESULT */], []);
                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getSearchResult({ query: _query });

                            case 3:
                                data = _context.sent;

                                commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["v" /* UPDATE_RESULT */], data);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["v" /* UPDATE_RESULT */], function (state, data) {
        state.result = data;
    })
});

/***/ }),

/***/ 470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(49);



var _mutations;



var localStorage = window.localStorage;
var FAVORITE_KEY = 'FAVORITE_NEWS';

var localList = void 0;
try {
    localList = JSON.parse(localStorage.getItem(FAVORITE_KEY)) || [];
} catch (e) {
    localList = [];
}

/* harmony default export */ __webpack_exports__["a"] = ({

    state: {
        newsFavorList: localList
    },

    actions: {
        addFavorItem: function addFavorItem(_ref, detail) {
            var commit = _ref.commit,
                state = _ref.state;

            if (state.newsFavorList.filter(function (item) {
                return item.nid === detail.nid;
            }).length) {
                return;
            }

            commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* ADD_FAVOR_ITEM */], {
                title: detail.title,
                nid: detail.nid,
                time: Date.now()
            });
        },
        removeFavorItem: function removeFavorItem(_ref2, detail) {
            var commit = _ref2.commit,
                state = _ref2.state;

            commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* DELETE_FAVOR_ITEM */], detail);
        }
    },

    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* ADD_FAVOR_ITEM */], function (state, item) {
        state.newsFavorList.push(item);
        localStorage.setItem(FAVORITE_KEY, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.newsFavorList));
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* DELETE_FAVOR_ITEM */], function (state, item) {
        state.newsFavorList = state.newsFavorList.filter(function (favor) {
            return favor.nid !== item.nid;
        });
        localStorage.setItem(FAVORITE_KEY, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.newsFavorList));
    }), _mutations)
});

/***/ }),

/***/ 472:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(49);








/* harmony default export */ __webpack_exports__["a"] = ({

    state: {
        detail: {}
    },

    actions: {
        getDetail: function getDetail(_ref, query) {
            var _this = this;

            var commit = _ref.commit;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["t" /* UPDATE_DETAIL */], {});
                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getNewsData({ nids: query.nid });

                            case 3:
                                data = _context.sent;

                                commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["t" /* UPDATE_DETAIL */], data && data.news && data.news[0] || {});

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["t" /* UPDATE_DETAIL */], function (state, detail) {
        state.detail = detail;
    })
});

/***/ }),

/***/ 473:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(49);



var _mutations;



var menuTabsLocalDataKey = 'menuTabsLocalDataKey';
var otherMenuTabsLocalDataKey = 'otherMenuTabsLocalDataKey';
var defaultCategory = '推荐';

function handleMenuTabsOriginData(menuData) {
    return menuData.split('|').map(function (item) {
        return { text: item };
    });
}

function setLocalMenuTabsData() {
    var menuTabsKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : menuTabsLocalDataKey;
    var menuTabsData = arguments[1];

    localStorage.setItem(menuTabsKey, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(menuTabsData));
}

function getLocalMenuTabsData() {
    var menuTabsKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : menuTabsLocalDataKey;


    try {
        var res = JSON.parse(localStorage.getItem(menuTabsKey));
        res.forEach(function (item) {
            delete item.active;
        });
    } catch (err) {}
}

var menuTabs = defaultCategory + '|\u672C\u5730|\u5A31\u4E50|\u793E\u4F1A|\u519B\u4E8B|\u5973\u4EBA|\u4E92\u8054\u7F51|\u79D1\u6280|\u751F\u6D3B|\u56FD\u9645|\u56FD\u5185|\u4F53\u80B2|\u6C7D\u8F66';
menuTabs = getLocalMenuTabsData(menuTabsLocalDataKey) || handleMenuTabsOriginData(menuTabs);
var activeIndex = 0;
var localTabData = localStorage.getItem('activeTab');
if (localTabData) {
    activeIndex = parseInt(localTabData.split('|')[0], 10);
}
menuTabs[activeIndex].active = true;

var otherMenuTabs = '房产|财经|时尚|教育|游戏|旅游|人文|创意';
otherMenuTabs = getLocalMenuTabsData(otherMenuTabsLocalDataKey) || handleMenuTabsOriginData(otherMenuTabs);

/* harmony default export */ __webpack_exports__["a"] = ({

    state: {
        menuTabs: menuTabs,
        otherMenuTabs: otherMenuTabs,
        category: 'abcd'
    },

    getters: {
        menuTabs: function menuTabs(state) {
            return state.menuTabs;
        },
        otherMenuTabs: function otherMenuTabs(state) {
            return state.otherMenuTabs;
        },
        category: function category(state) {
            var activeTab = state.menuTabs.find(function (tab) {
                return tab.active;
            });
            return activeTab ? activeTab.text : defaultCategory;
        }
    },

    actions: {
        setActiveTab: function setActiveTab(_ref, category) {
            var commit = _ref.commit;

            commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* SET_NEWS_ACTIVE_TAB */], category);
        },
        addCategory: function addCategory(_ref2, _ref3) {
            var commit = _ref2.commit;
            var category = _ref3.text;

            commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* ADD_CATEGORY */], category);
        },
        delCategory: function delCategory(_ref4, tabItem) {
            var commit = _ref4.commit;

            commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* DEL_CATEGORY */], tabItem.text);
        }
    },

    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* SET_NEWS_ACTIVE_TAB */], function (state, category) {
        state.menuTabs = state.menuTabs.map(function (item) {
            item.active = category === item.text;
            return item;
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* DEL_CATEGORY */], function (state, category) {
        state.menuTabs.forEach(function (item, index) {
            if (category === item.text) {
                var deletedCategoryObj = state.menuTabs.splice(index, 1)[0];
                state.otherMenuTabs.unshift(deletedCategoryObj);
                setLocalMenuTabsData(otherMenuTabsLocalDataKey, state.otherMenuTabs);
            }
        });
        setLocalMenuTabsData(menuTabsLocalDataKey, state.menuTabs);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* ADD_CATEGORY */], function (state, category) {
        state.otherMenuTabs.forEach(function (item, index) {
            if (category === item.text) {
                var deletedCategoryObj = state.otherMenuTabs.splice(index, 1)[0];
                state.menuTabs.push(deletedCategoryObj);
                setLocalMenuTabsData(menuTabsLocalDataKey, state.menuTabs);
            }
        });
        setLocalMenuTabsData(otherMenuTabsLocalDataKey, state.otherMenuTabs);
    }), _mutations)
});

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(475)
  __webpack_require__(476)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(499),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e64dc28",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 475:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppHeader__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppSidebar__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppSidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AppSidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MenuTabs_vue__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MenuTabs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_MenuTabs_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: {
        AppHeader: __WEBPACK_IMPORTED_MODULE_2__components_AppHeader___default.a,
        AppSidebar: __WEBPACK_IMPORTED_MODULE_3__components_AppSidebar___default.a,
        MenuTabs: __WEBPACK_IMPORTED_MODULE_5__components_MenuTabs_vue___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('appShell', ['appHeader', 'appSidebar', 'pageTransitionName', 'overflowScrollingTouch', 'enableSwipeBack', 'historyPageScrollTop']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['route'])),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('appShell', ['setPageSwitching']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('appShell/appSidebar', ['showSidebar', 'hideSidebar']), {
        handleBeforeEnter: function handleBeforeEnter(el) {
            this.setPageSwitching(true);
            __WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* default */].$emit('app-page:before-enter');
        },
        handleAfterEnter: function handleAfterEnter(el) {
            el.classList.remove('enable-scroll');
            var scrollTop = this.historyPageScrollTop[this.route.path];
            window.scrollTo(0, scrollTop);
            this.setPageSwitching(false);
        },
        handleAfterLeave: function handleAfterLeave(el) {
            el.classList.remove('enable-scroll');
            this.setPageSwitching(false);
            __WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* default */].$emit('app-page:after-leave');
        },
        handleClickHeaderBack: function handleClickHeaderBack() {
            this.$router.go(-1);
        },
        handleClickHeaderMenu: function handleClickHeaderMenu() {
            this.showSidebar();
        }
    }),
    mounted: function mounted() {
        var _this = this;

        var $appView = this.$el.querySelector('.app-view-wrapper');
        var touchStartPosX = void 0;
        var touchMoveX = void 0;
        var touchStartPosY = void 0;
        var touchMoveY = void 0;
        var minOffset = 60;

        var touchstart = function touchstart(e) {
            touchStartPosX = e.touches[0].pageX;
            touchStartPosY = e.touches[0].pageY;
        };

        var touchmove = function touchmove(e) {
            touchMoveX = e.touches[0].pageX - touchStartPosX;
            touchMoveY = e.touches[0].pageY - touchStartPosY;
        };

        var touchend = function touchend(e) {
            if (touchMoveX > minOffset && Math.abs(touchMoveY) < minOffset && _this.enableSwipeBack) {
                _this.$router.go(-1);
            }
            touchMoveX = 0;
            touchMoveY = 0;
        };

        $appView.addEventListener('touchstart', touchstart);
        $appView.addEventListener('touchmove', touchmove);
        $appView.addEventListener('touchend', touchend);
    }
});

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(479)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(481),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ad8f8a4c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 479:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 480:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__(130);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'appHeader',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('appShell/appHeader', ['show', 'showMenu', 'showFavor', 'showBack', 'showLogo', 'logoIcon', 'title', 'actions']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('appShell', ['isPageSwitching'])),
    methods: {
        handleClick: function handleClick(source) {
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                handler = _ref.handler,
                actionIdx = _ref.actionIdx,
                route = _ref.route;

            if (this.isPageSwitching) {
                return;
            }
            var eventData = {};

            if (source === 'action') {
                eventData.actionIdx = actionIdx;
            }
            if (source === 'toggle') {
                eventData.handler = handler;
            }

            this.$emit('click-' + source, eventData);

            __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* default */].$emit('app-header:click-' + source, eventData);

            if (route) {
                this.$router.push(route);
            }
        }
    }
});

/***/ }),

/***/ 481:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "app-header-wrapper"
  }, [_c('div', {
    staticClass: "app-header-left"
  }, [(_vm.showMenu) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleClick('menu')
      }
    }
  }, [_c('v-icon', {
    staticClass: "app-header-icon"
  }, [_vm._v("menu")])], 1) : _vm._e(), _vm._v(" "), (_vm.showFavor) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleClick('favor')
      }
    }
  }, [_c('v-icon', {
    staticClass: "app-header-icon"
  }, [_vm._v("folder")])], 1) : _vm._e(), _vm._v(" "), (_vm.showBack) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleClick('back')
      }
    }
  }, [_c('v-icon', {
    staticClass: "app-header-icon"
  }, [_vm._v("arrow_back")])], 1) : _vm._e(), _vm._v(" "), (_vm.showLogo) ? _c('div', {
    on: {
      "click": function($event) {
        _vm.handleClick('logo')
      }
    }
  }, [_vm._t("logo", [_c('v-icon', {
    staticClass: "app-header-icon"
  }, [_vm._v(_vm._s(_vm.logoIcon))])])], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "app-header-middle"
  }, [_vm._t("title", [_vm._v("\n                " + _vm._s(_vm.title) + "\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "app-header-right"
  }, [_vm._l((_vm.actions), function(action, actionIdx) {
    return _vm._t("actions", [(action.toggle) ? _c('v-btn', {
      class: action.toggleClassObj,
      attrs: {
        "icon": "icon"
      },
      nativeOn: {
        "click": function($event) {
          _vm.handleClick('toggle', {
            actionIdx: actionIdx,
            handler: action.toggleHandler
          })
        }
      }
    }, [_c('v-icon', {
      staticClass: "app-header-icon"
    }, [_vm._v(_vm._s(action.toggleIcon))])], 1) : _c('v-btn', {
      attrs: {
        "icon": "icon"
      },
      nativeOn: {
        "click": function($event) {
          _vm.handleClick('action', {
            actionIdx: actionIdx,
            route: action.route
          })
        }
      }
    }, [(action.svg) ? _c('icon', {
      staticClass: "app-header-icon",
      attrs: {
        "name": action.svg
      }
    }) : (action.icon) ? _c('v-icon', {
      staticClass: "app-header-icon"
    }, [_vm._v(_vm._s(action.icon))]) : _vm._e()], 1)], {
      icon: action.icon,
      route: action.route
    })
  })], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(483)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(494),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-215f825f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 483:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Login__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Login__);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            toast: false,
            showLogin: false,
            aclogout: false
        };
    },

    components: {
        Sidebar: __WEBPACK_IMPORTED_MODULE_2__Sidebar___default.a,
        Login: __WEBPACK_IMPORTED_MODULE_3__Login___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('appShell/appSidebar', ['show', 'title', 'user', 'blocks', 'enableSwipeOut']), {
        sidebarStatus: {
            get: function get() {
                return this.show;
            },
            set: function set(val) {
                if (val) {
                    this.$emit('show-sidebar');
                } else {
                    this.$emit('hide-sidebar');
                }
            }
        }
    }),
    methods: {
        close: function close() {
            this.sidebarStatus = false;
        },
        closeAndGo: function closeAndGo(route, action) {
            var _this = this;

            if (action) {
                this[action] && this[action]();
                return;
            }
            if (!route) {
                clearTimeout(this.timer);
                this.toast = true;
                this.timer = setTimeout(function () {
                    _this.toast = false;
                }, 2500);
                return;
            }

            this.$router.push(route);
            this.close();
        },
        login: function login() {
            this.showLogin = true;
        },
        logout: function logout() {
            var _this2 = this;

            this.aclogout = true;
            setTimeout(function () {
                _this2.aclogout = false;
            }, 100);
        },
        closeLogin: function closeLogin() {
            this.showLogin = false;
        }
    }
});

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(486)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(489),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-83387fb0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 486:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_iscroll_build_iscroll_lite__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_iscroll_build_iscroll_lite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_iscroll_build_iscroll_lite__);




var rAF = window.requestAnimationFrame || window.webkitRequestAnimationFrame || function (cb) {
    window.setTimeout(cb, 1000 / 60);
};

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        value: {
            'type': Boolean,
            'default': false
        },
        width: {
            'type': Number,
            'default': 0.75
        },
        enableSwipeOut: {
            'type': Boolean,
            'default': false
        }
    },
    data: function data() {
        return {
            showStatus: this.value,
            startX: 0,
            startY: 0,
            wrapperClass: {
                'expand': false,
                'collapse': true,
                'w-left': true
            },
            opacity: 0,
            iscroll: null
        };
    },

    computed: {
        itsWidth: function itsWidth() {
            return this.width < 1 ? Math.round(this.width * document.documentElement.clientWidth) : this.width;
        },
        widthProp: function widthProp() {
            return this.itsWidth + 'px';
        }
    },
    watch: {
        value: function value() {
            this.showStatus = this.value;
        },
        showStatus: function showStatus(val) {
            this.toggleScroll(val);
            this.$emit('input', val);
        }
    },
    methods: {
        toggleTouchStart: function toggleTouchStart(e) {
            if (!this.enableSwipeOut) {
                return;
            }

            if (this.wrapperClass.expand) {
                return;
            }

            var _e$touches$ = e.touches[0],
                clientX = _e$touches$.clientX,
                clientY = _e$touches$.clientY;

            this.startX = clientX;
            this.startY = clientY;
        },
        toggleTouchMove: function toggleTouchMove(e) {
            var _this = this;

            if (!this.enableSwipeOut) {
                return;
            }

            if (this.wrapperClass.expand) {
                return;
            }

            var _e$touches$2 = e.touches[0],
                clientX = _e$touches$2.clientX,
                clientY = _e$touches$2.clientY;

            var x = clientX - this.startX;

            if (x > 5 && Math.abs(clientY - this.startY) / x < 0.577) {
                this.wrapperClass.expand = true;
                this.wrapperClass.collapse = false;

                this.$nextTick(function () {
                    _this.bindScroll(e);
                });
            }
        },
        toggleClick: function toggleClick(e) {
            if (this.iscroll) {
                this.forceToggleScroll(false);
            }
        },
        bindScroll: function bindScroll(e) {
            var _this2 = this;

            if (this.iscroll) {
                return;
            }

            this.iscroll = new __WEBPACK_IMPORTED_MODULE_0_iscroll_build_iscroll_lite___default.a(this.$refs.sidebarWrapper, {
                eventPassthrough: true,
                scrollY: false,
                scrollX: true,
                bounce: false,
                startX: -this.itsWidth
            });

            this.changeOpacity();

            this.iscroll.on('scrollEnd', function () {
                var _iscroll = _this2.iscroll,
                    directionX = _iscroll.directionX,
                    x = _iscroll.x;

                if (x === 0) {
                    _this2.showStatus = true;
                    return;
                }

                if (x === -_this2.itsWidth) {
                    _this2.unbindScroll();
                    _this2.showStatus = false;
                    return;
                }

                if (directionX > 0) {
                    _this2.forceToggleScroll(false);
                } else if (directionX < 0) {
                    _this2.forceToggleScroll(true);
                } else {
                    _this2.showStatus = !_this2.showStatus;
                }
            });

            e && this.iscroll._start(e);
        },
        unbindScroll: function unbindScroll() {
            if (!this.iscroll) {
                return;
            }

            this.iscroll.destroy();
            this.iscroll = null;

            this.wrapperClass.expand = false;
            this.wrapperClass.collapse = true;
            this.opacity = 0;

            this.$refs.sidebarScroller.setAttribute('style', 'padding-left:' + this.widthProp);
        },
        toggleScroll: function toggleScroll(val) {
            var _this3 = this;

            if (val) {
                this.wrapperClass.expand = true;
                this.wrapperClass.collapse = false;

                this.$nextTick(function () {
                    if (!_this3.iscroll) {
                        _this3.bindScroll();
                    }

                    if (_this3.iscroll.x < 0) {
                        setTimeout(function () {
                            _this3.iscroll && _this3.iscroll.scrollTo(0, 0, 200);
                        }, 10);
                    }
                });
            } else {
                if (this.iscroll && this.iscroll.x > -this.itsWidth) {
                    setTimeout(function () {
                        _this3.iscroll.scrollTo(-_this3.itsWidth, 0, 200);
                    });
                }
            }
        },
        forceToggleScroll: function forceToggleScroll(val) {
            if (this.showStatus === val) {
                this.toggleScroll(val);
            } else {
                this.showStatus = val;
            }
        },
        changeOpacity: function changeOpacity() {
            var _this4 = this;

            if (this.wrapperClass.expand && this.iscroll) {
                setTimeout(function () {
                    if (!_this4.iscroll) {
                        return;
                    }
                    _this4.opacity = (_this4.iscroll.x + _this4.itsWidth) / _this4.itsWidth * 0.5;
                }, 80);
                rAF(this.changeOpacity.bind(this));
            }
        }
    }
});

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableSwipeOut),
      expression: "enableSwipeOut"
    }],
    ref: "sidebarWrapper",
    staticClass: "sidebar-wrapper",
    class: _vm.wrapperClass
  }, [_c('div', {
    ref: "sidebarScroller",
    staticClass: "sidebar-scroller",
    style: ({
      'padding-left': _vm.widthProp
    })
  }, [_c('div', {
    staticClass: "sidebar-main",
    style: ({
      width: _vm.widthProp
    }),
    on: {
      "scroll": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    ref: "sidebarToggle",
    staticClass: "touch-toggle",
    style: ({
      'opacity': _vm.opacity,
      'padding-left': _vm.widthProp
    }),
    on: {
      "touchstart": _vm.toggleTouchStart,
      "touchmove": _vm.toggleTouchMove,
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleClick($event)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ENABLE_PAGE_TRANSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DISABLE_PAGE_TRANSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_PAGE_SWITCHING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_PAGE_TRANSITION_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_APP_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_APP_BOTTOM_NAV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVATE_APP_BOTTOM_NAV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_SIDEBAR_VISIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SAVE_SCROLLTOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_SWIPE_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return UPDATE_OVERFLOW_SCROLLING_TOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_USER_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_SIDEBAR_BLOCKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RM_SIDEBAR_BLOCKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return UPDATE_SWIPE_BACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_NEWS_DATA; });
/* unused harmony export SET_LIST_FROM_CACHE */
/* unused harmony export SET_NEWS_LIST */
/* unused harmony export SET_NEWS_CATEGORY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_NEWS_ACTIVE_TAB; });
/* unused harmony export SET_NEWS_DETAIL */
/* unused harmony export ADD_QUERY_HISTORY */
/* unused harmony export DELETE_QUERY_HISTORY */
/* unused harmony export SET_QUERY_RESULT */
/* unused harmony export SET_PREVIEW_DATA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DEL_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_CATEGORY; });
/* unused harmony export SET_SEARCH_RESULT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return UPDATE_RESULT; });
/* unused harmony export SET_NEWS_FAVOR_LIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_FAVOR_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELETE_FAVOR_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return UPDATE_DETAIL; });


var ENABLE_PAGE_TRANSITION = 'ENABLE_PAGE_TRANSITION';
var DISABLE_PAGE_TRANSITION = 'DISABLE_PAGE_TRANSITION';
var SET_PAGE_SWITCHING = 'SET_PAGE_SWITCHING';
var SET_PAGE_TRANSITION_NAME = 'SET_PAGE_TRANSITION_NAME';
var SET_APP_HEADER = 'SET_APP_HEADER';
var SET_APP_BOTTOM_NAV = 'SET_APP_BOTTOM_NAV';
var ACTIVATE_APP_BOTTOM_NAV = 'ACTIVATE_APP_BOTTOM_NAV';
var SET_SIDEBAR_VISIBILITY = 'SET_SIDEBAR_VISIBILITY';
var SAVE_SCROLLTOP = 'SAVE_SCROLLTOP';
var SET_SWIPE_OUT = 'SET_SWIPE_OUT';
var UPDATE_OVERFLOW_SCROLLING_TOUCH = 'UPDATE_OVERFLOW_SCROLLING_TOUCH';
var SET_USER_INFO = 'SET_USER_INFO';
var ADD_SIDEBAR_BLOCKS = 'ADD_SIDEBAR_BLOCKs';
var RM_SIDEBAR_BLOCKS = 'RM_SIDEBAR_BLOCKS';
var UPDATE_SWIPE_BACK = 'UPDATE_SWIPE_BACK';

var SET_NEWS_DATA = 'SET_NEWS_DATA';
var SET_LIST_FROM_CACHE = 'SET_LIST_FROM_CACHE';
var SET_NEWS_LIST = 'SET_NEWS_LIST';
var SET_NEWS_CATEGORY = 'SET_NEWS_CATEGORY';
var SET_NEWS_ACTIVE_TAB = 'SET_NEWS_ACTIVE_TAB';
var SET_NEWS_DETAIL = 'SET_NEWS_DETAIL';
var ADD_QUERY_HISTORY = 'ADD_QUERY_HISTORY';
var DELETE_QUERY_HISTORY = 'DELETE_QUERY_HISTORY';
var SET_QUERY_RESULT = 'SET_QUERY_RESULT';
var SET_PREVIEW_DATA = 'SET_PREVIEW_DATA';
var DEL_CATEGORY = 'DEL_CATEGORY';
var ADD_CATEGORY = 'ADD_CATEGORY';
var SET_SEARCH_RESULT = 'SET_SEARCH_RESULT';

var UPDATE_RESULT = 'UPDATE_RESULT';

var SET_NEWS_FAVOR_LIST = 'SET_NEWS_FAVOR_LIST';
var ADD_FAVOR_ITEM = 'ADD_FAVOR_ITEM';
var DELETE_FAVOR_ITEM = 'DELETE_FAVOR_ITEM';

var UPDATE_DETAIL = 'UPDATE_DETAIL';

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(491)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(493),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0dd352b5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 491:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(51);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'login',
    props: ['show', 'logout'],
    data: function data() {
        return {
            username: '',
            password: '',
            wrapperWidth: document.body.clientWidth,
            processing: false,
            useDefaultAccount: false
        };
    },

    computed: {},
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('appShell/appSidebar', ['accountLogin', 'accountLogout']), {
        close: function close() {
            this.$emit('close-login');
        },
        validate: function validate() {
            if (!this.username.length) {
                return false;
            }
            if (!this.password.length) {
                return false;
            }
            return true;
        },
        submit: function submit() {
            var _this = this;

            if (!this.validate()) {
                return;
            }

            this.showLoginLoading();

            this.accountLogin({
                name: this.username,
                pwd: this.password
            }).then(function () {
                _this.storeCred();
            }).then(function () {
                _this.hideLoginLoading();
                _this.close();
                _this.useDefaultAccount = true;
            });
        },
        changeAccount: function changeAccount() {
            this.username = '';
            this.password = '';
            this.useDefaultAccount = false;
        },
        storeCred: function storeCred() {
            if (navigator.credentials) {
                var cred = new PasswordCredential({
                    id: this.username,
                    password: this.password,
                    name: this.username,
                    iconURL: 'https://gss0.bdstatic.com/9rkZbzqaKgQUohGko9WTAnF6hhy/movie/edison/assets/android-chrome-192x192_1501062228038.png'
                });
                return navigator.credentials.store(cred);
            }

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
        },
        toLogout: function toLogout() {
            var _this2 = this;

            if (navigator.credentials) {
                navigator.credentials.requireUserMediation().then(function () {
                    _this2.accountLogout();
                });
                return;
            }

            this.accountLogout();
        },
        showLoginLoading: function showLoginLoading() {
            this.processing = true;
        },
        hideLoginLoading: function hideLoginLoading() {
            this.processing = false;
        }
    }),
    created: function created() {
        var _this3 = this;

        if (navigator.credentials) {
            navigator.credentials.get({
                password: true
            }).then(function (cred) {
                if (cred) {
                    switch (cred.type) {
                        case 'password':
                            if (cred.password === undefined) {
                                break;
                            }
                            _this3.username = cred.id;
                            _this3.password = cred.password;
                            _this3.useDefaultAccount = true;
                            break;
                        default:
                            break;
                    }
                }
            });
        }
    },

    watch: {
        logout: function logout(value, old) {
            if (value) {
                this.toLogout();
            }
        }
    }
});

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('transition', {
    attrs: {
      "name": "login"
    }
  }, [_c('div', {
    staticClass: "login-wrapper",
    style: ({
      width: _vm.wrapperWidth + 'px'
    })
  }, [_c('header', [_c('v-btn', {
    attrs: {
      "light": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('span', [_vm._v("登录")])], 1), _vm._v(" "), (!_vm.useDefaultAccount) ? _c('div', {
    staticClass: "login-content"
  }, [_c('v-text-field', {
    attrs: {
      "name": "username",
      "single-line": "",
      "prepend-icon": "email",
      "placeholder": "用户名",
      "type": "text",
      "autocomplete": "name"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "password",
      "single-line": "",
      "prepend-icon": "lock",
      "placeholder": "密码",
      "type": "password",
      "autocomplete": "new-password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sign-in-btn",
    on: {
      "click": _vm.submit
    }
  }, [_c('v-btn', [_vm._v("登录")])], 1)], 1) : _c('div', {
    staticClass: "login-content"
  }, [_c('p', {
    staticClass: "sign-in-already-tip"
  }, [_vm._v("您已经登录过您的账户，可以直接访问")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "hidden-filed",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "hidden-filed",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "sign-in-checkbox",
    attrs: {
      "label": _vm.username,
      "value": _vm.username,
      "color": "primary",
      "hide-details": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sign-in-btn",
    on: {
      "click": _vm.submit
    }
  }, [_c('v-btn', [_vm._v("现在访问")])], 1), _vm._v(" "), _c('p', {
    staticClass: "sign-in-change",
    on: {
      "click": _vm.changeAccount
    }
  }, [_vm._v("换个账户登录")])], 1), _vm._v(" "), (_vm.processing) ? _c('v-progress-circular', {
    staticClass: "primary--text login-progress",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sidebar', {
    attrs: {
      "enableSwipeOut": _vm.enableSwipeOut
    },
    model: {
      value: (_vm.sidebarStatus),
      callback: function($$v) {
        _vm.sidebarStatus = $$v
      },
      expression: "sidebarStatus"
    }
  }, [_c('div', {
    staticClass: "app-sidebar-content"
  }, [_c('div', {
    staticClass: "app-sidebar-header"
  }, [_c('div', {
    staticClass: "user-avatar"
  }, [_c('v-icon', {
    staticClass: "user-avatar-icon",
    attrs: {
      "light": ""
    }
  }, [_vm._v("face")])], 1), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "user-name"
  }, [_c('v-icon', [_vm._v("person")]), _vm._v(_vm._s(_vm.user.name))], 1), _vm._v(" "), _c('div', {
    staticClass: "user-location"
  }, [_c('v-icon', [_vm._v("room")]), _vm._v(_vm._s(_vm.user.location))], 1), _vm._v(" "), _c('div', {
    staticClass: "user-email"
  }, [_c('v-icon', [_vm._v("email")]), _vm._v(_vm._s(_vm.user.email))], 1)]) : _c('p', {
    staticClass: "user-login",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])]), _vm._v(" "), (_vm.blocks) ? _c('div', {
    staticClass: "app-sidebar-blocks"
  }, [_c('ul', _vm._l((_vm.blocks), function(block, index) {
    return _c('li', {
      key: index,
      staticClass: "app-sidebar-block"
    }, [(block.sublistTitle) ? _c('div', {
      staticClass: "sub-list-title"
    }, [_vm._v(_vm._s(block.sublistTitle))]) : _vm._e(), _vm._v(" "), (block.list) ? _c('ul', _vm._l((block.list), function(item) {
      return _c('li', {
        directives: [{
          name: "ripple",
          rawName: "v-ripple",
          value: ({
            class: 'grey--text'
          }),
          expression: "{class: 'grey--text'}"
        }],
        key: item.text,
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.closeAndGo(item.route, item.action)
          }
        }
      }, [(item.icon || item.image || item.svg) ? _c('span', {
        staticClass: "app-sidebar-block-left-icon"
      }, [(item.image) ? _c('img', {
        attrs: {
          "src": item.image,
          "alt": item.alt
        }
      }) : (item.svg) ? _c('icon', {
        attrs: {
          "name": item.svg
        }
      }) : (item.icon) ? _c('v-icon', {
        staticClass: "grey--text text--lighten-1"
      }, [_vm._v(_vm._s(item.icon))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.text) ? _c('span', {
        staticClass: "app-sidebar-block-text"
      }, [_vm._v(_vm._s(item.text))]) : _vm._e()])
    })) : _vm._e()])
  }))]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "toast"
    }
  }, [(_vm.toast) ? _c('p', {
    staticClass: "app-sidebar-toast"
  }, [_vm._v("Only a demo")]) : _vm._e()])], 1), _vm._v(" "), _c('login', {
    attrs: {
      "show": _vm.showLogin,
      "logout": _vm.aclogout
    },
    on: {
      "close-login": _vm.closeLogin
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(496)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(498),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d4ead03e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 496:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_iscroll__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_iscroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_iscroll__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'menu-tabs',

    data: function data() {
        return {
            opend: false,
            tabWidth: 72,
            extraWidth: 40,
            clientWidth: document.documentElement.clientWidth
        };
    },
    created: function created() {},


    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['menuTabs', 'otherMenuTabs']), {
        len: function len() {
            return this.menuTabs.length;
        }
    }),

    methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['addCategory', 'setActiveTab', 'delCategory']), {
        selectItem: function selectItem(item, noFold) {
            if (!noFold) {
                this.opend = false;
            }
            this.setActiveTab(item.text);
            this.$store.dispatch('selectTab', item.text);
            this.setMenuTabsPos();
        },
        toggleEditWrapper: function toggleEditWrapper() {
            this.opend = !this.opend;
        },
        addItemToSelected: function addItemToSelected(tabItem) {
            this.addCategory(tabItem);
            this.refreshScroll();
        },
        delSelectedItem: function delSelectedItem(tabItem) {

            if (tabItem.active) {
                this.selectItem(this.menuTabs[0], true);
            }

            this.delCategory(tabItem);
            this.refreshScroll();
        },
        setMenuTabsPos: function setMenuTabsPos() {
            var activeIndex = 0;
            this.menuTabs.forEach(function (item, index) {
                if (item.active) {
                    activeIndex = index;
                    localStorage.setItem('activeTab', index + '|' + item.text);
                }
            });

            var menuTabsScroll = this.menuTabsScroll;
            var scrollLeft = this.tabWidth * (activeIndex - 2);
            var maxScrollLeft = Math.abs(menuTabsScroll.maxScrollX);

            if (scrollLeft <= 0) {
                scrollLeft = 0;
            }
            if (scrollLeft > maxScrollLeft) {
                scrollLeft = maxScrollLeft;
            }
            if (scrollLeft !== Math.abs(menuTabsScroll.x)) {
                menuTabsScroll.scrollTo(-scrollLeft, 0, 300);
            }
        },
        leave: function leave(el) {
            el.style.display = 'none';
        },
        enter: function enter(el) {
            el.style.opacity = 0;
            setTimeout(function () {
                return el.style.opacity = 1;
            }, 200);
        },
        refreshScroll: function refreshScroll() {
            var _this = this;

            setTimeout(function () {
                _this.menuTabsScroll.refresh();
            });
        }
    }),
    activated: function activated() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this2.setMenuTabsPos();

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }))();
    },
    mounted: function mounted() {
        this.menuTabsScroll = new __WEBPACK_IMPORTED_MODULE_4_iscroll___default.a(this.$refs.menuTabsWrap, {
            momentum: true,
            scrollX: true,
            scrollY: false,
            click: true,
            tap: true
        });
    }
});

/***/ }),

/***/ 498:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-left"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path === '/'),
      expression: "$route.path === '/'"
    }],
    class: {
      'menu-tabs': true, opend: _vm.opend
    },
    style: ({
      width: _vm.clientWidth + 'px'
    })
  }, [_c('div', {
    ref: "menuTabsWrap",
    staticClass: "menu-tabs-wrap"
  }, [_c('div', {
    staticClass: "menu-tabs-wrap-inner",
    style: ({
      width: _vm.len * _vm.tabWidth + _vm.extraWidth + 'px'
    })
  }, _vm._l((_vm.menuTabs), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "menu-tabs-item",
      on: {
        "click": function($event) {
          _vm.selectItem(item)
        }
      }
    }, [_c('span', {
      class: {
        active: item.active
      }
    }, [_vm._v(_vm._s(item.text))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "edit",
    on: {
      "click": _vm.toggleEditWrapper
    }
  }, [_c('span', [_vm._v("+")])]), _vm._v(" "), _c('div', {
    staticClass: "edit-wrapper"
  }, [_c('div', {
    staticClass: "edit-wrapper-inner"
  }, [_c('p', {
    staticClass: "menu-title"
  }, [_vm._v("我的栏目"), _c('span', [_vm._v("点击删除")])]), _vm._v(" "), _c('transition-group', {
    staticClass: "edit-menu-tabs-wrapper",
    on: {
      "leave": _vm.leave,
      "enter": _vm.enter
    }
  }, _vm._l((_vm.menuTabs), function(item, i) {
    return (i !== 0) ? _c('div', {
      key: item.text,
      staticClass: "edit-menu-tabs-item",
      on: {
        "click": function($event) {
          _vm.delSelectedItem(item)
        }
      }
    }, [_c('span', {
      class: {
        active: item.active
      }
    }, [_vm._v("- " + _vm._s(item.text))])]) : _vm._e()
  })), _vm._v(" "), _c('p', {
    staticClass: "menu-title"
  }, [_vm._v("推荐栏目"), _c('span', [_vm._v("点击添加")])]), _vm._v(" "), _c('transition-group', {
    staticClass: "edit-menu-tabs-wrapper",
    on: {
      "leave": _vm.leave,
      "enter": _vm.enter
    }
  }, _vm._l((_vm.otherMenuTabs), function(item, i) {
    return _c('div', {
      key: item.text,
      staticClass: "edit-menu-tabs-item",
      on: {
        "click": function($event) {
          _vm.addItemToSelected(item)
        }
      }
    }, [_c('span', [_vm._v("+ " + _vm._s(item.text))])])
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "menu-tab-mask",
    on: {
      "click": _vm.toggleEditWrapper
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 499:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "app-shell"
  }, [_c('app-header', {
    staticClass: "app-shell-header",
    on: {
      "click-menu": _vm.handleClickHeaderMenu,
      "click-back": _vm.handleClickHeaderBack
    }
  }, [_c('template', {
    slot: "logo"
  })], 2), _vm._v(" "), _c('menu-tabs', {
    staticClass: "menu-tabs"
  }), _vm._v(" "), _c('app-sidebar', {
    on: {
      "hide-sidebar": _vm.hideSidebar,
      "show-sidebar": _vm.showSidebar
    }
  }), _vm._v(" "), _c('div', {
    ref: "appViewWrapper",
    staticClass: "app-view-wrapper",
    class: {
      'app-view-with-header': _vm.appHeader.show
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.pageTransitionName
    },
    on: {
      "before-enter": _vm.handleBeforeEnter,
      "after-enter": _vm.handleAfterEnter,
      "after-leave": _vm.handleAfterLeave
    }
  }, [_c('keep-alive', [(!_vm.$route.meta.notKeepAlive) ? _c('router-view', {
    key: _vm.$route.fullPath,
    ref: "appView",
    staticClass: "app-view",
    class: {
      'overflow-scrolling-touch': _vm.overflowScrollingTouch
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.pageTransitionName
    },
    on: {
      "before-enter": _vm.handleBeforeEnter,
      "after-enter": _vm.handleAfterEnter,
      "after-leave": _vm.handleAfterLeave
    }
  }, [(_vm.$route.meta.notKeepAlive) ? _c('router-view', {
    key: _vm.$route.fullPath,
    ref: "appView",
    staticClass: "app-view",
    class: {
      'overflow-scrolling-touch': _vm.overflowScrollingTouch
    }
  }) : _vm._e()], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(501)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(503),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 501:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ 503:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.klass,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path, i) {
    return _c('path', _vm._b({
      key: ("path-" + i)
    }, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon, i) {
    return _c('polygon', _vm._b({
      key: ("polygon-" + i)
    }, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(506)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(508),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e453c72",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 506:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            percent: 0,
            show: false,
            canSuccess: true,
            duration: 3000,
            height: '2px',
            color: '#ffca2b',
            failedColor: '#ff0000'
        };
    },

    methods: {
        start: function start() {
            var _this = this;

            this.show = true;
            this.canSuccess = true;
            if (this._timer) {
                clearInterval(this._timer);
                this.percent = 0;
            }
            this._cut = 10000 / Math.floor(this.duration);
            this._timer = setInterval(function () {
                _this.increase(_this._cut * Math.random());
                if (_this.percent > 95) {
                    _this.finish();
                }
            }, 100);
            return this;
        },
        set: function set(num) {
            this.show = true;
            this.canSuccess = true;
            this.percent = Math.floor(num);
            return this;
        },
        get: function get() {
            return Math.floor(this.percent);
        },
        increase: function increase(num) {
            this.percent = this.percent + Math.floor(num);
            return this;
        },
        decrease: function decrease(num) {
            this.percent = this.percent - Math.floor(num);
            return this;
        },
        finish: function finish() {
            this.percent = 100;
            this.hide();
            return this;
        },
        pause: function pause() {
            clearInterval(this._timer);
            return this;
        },
        hide: function hide() {
            var _this2 = this;

            clearInterval(this._timer);
            this._timer = null;
            setTimeout(function () {
                _this2.show = false;
                _this2.$nextTick(function () {
                    setTimeout(function () {
                        _this2.percent = 0;
                    }, 200);
                });
            }, 500);
            return this;
        },
        fail: function fail() {
            this.canSuccess = false;
            return this;
        }
    }
});

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress",
    style: ({
      'width': _vm.percent + '%',
      'height': _vm.height,
      'background-color': _vm.canSuccess ? _vm.color : _vm.failedColor,
      'opacity': _vm.show ? 1 : 0
    })
  })
},staticRenderFns: []}

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);







var API_PATH = 'https://newspwa.baidu.com/api/mockup/realNews/news';

var _screen = screen,
    screenSizeWidth = _screen.width,
    screenSizeHeight = _screen.height;


function getParamT(_ref) {
    var category = _ref.category,
        nids = _ref.nids;

    if (nids) {
        return 'recommendinfo';
    }

    if (category === 'getbodyinfo') {
        return 'getbodyinfo';
    }

    if (category === '推荐') {
        return 'newchosenlist';
    }

    if (category === '本地') {
        return 'localnewslist';
    }

    return 'recommendlist';
}

/* harmony default export */ __webpack_exports__["a"] = ({
    getNewsData: function getNewsData(params) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            var data;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_3_axios___default()(API_PATH, {
                                params: {
                                    tn: 'bdapibaiyue',
                                    t: getParamT(params),
                                    mid: '03c7a16f2e8028127e42c5f7ca9e210b',
                                    ts: 0,
                                    topic: params.category,
                                    type: 'info',
                                    token: 'info',
                                    ln: 20,
                                    an: 20,
                                    withtopic: 0,
                                    wf: 1,
                                    ver: params.ver || 4,
                                    pd: 'webapp',

                                    nids: params.nids,

                                    nid: params.nid,

                                    remote_device_type: 1,
                                    os_type: 1,
                                    screen_size_width: screenSizeWidth,
                                    screen_size_height: screenSizeHeight,

                                    action: 1
                                },
                                withCredentials: true
                            });

                        case 2:
                            data = _context.sent;
                            return _context.abrupt('return', data.data.data);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    getSearchResult: function getSearchResult(params) {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var data, news;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _this2.getNewsData({ category: '推荐' });

                        case 2:
                            data = _context2.sent;
                            news = data && data.news || [];
                            return _context2.abrupt('return', news);

                        case 5:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    getUserInfo: function getUserInfo() {
        var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '2459115';

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
            resolve({
                userName: 'Baidu',
                messageCount: 10
            });
        });
    }
});

/***/ })

},[193]);


// WEBPACK FOOTER //
// static/js/app.8731410b919cb2b68fc2.js